import React, { Fragment } from 'react';
import { SvgIcon, SvgIconProps } from '../components';

export default function HomeTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <Fragment>
        <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
      </Fragment>
    </SvgIcon>
  );
}
